import React, { Component } from "react";
import moment from "moment";
import DatePicker from "react-date-picker";
import Select from "react-select";
import HmacSHA256 from "crypto-js/hmac-sha256";

import axios from "axios";
import LoadingSpinner from "../../components/Input/LoadingSpinner";
import { thousands_separators } from "../../components/Methods/Methods";


class RaportGrumbullimeArka extends Component {
  state = {
    pNga: new Date(),
    pDeri: new Date(),
    date: new Date(),
    posts: [{}],
    Id: "",
    perdorues: { value: "True", label: "Te Gjitha" },
    terminal: { value: "True", label: "Te Gjitha" }, //[],
    data2: [],
    data3: [],
    data3: [{}],
    ProcesorId: "",
    Agjensi: "",
    selectedOption: null,
    loading: false,
    PerdoruesAgjensi: "",
    Terminal: "",
    KPLeke: "",
    KPEuro: "",
    TotShtese: "",
    TotTakse: "",
    TotSig: "",
    TotTvsh: "",
    TotCmimiBaze: "",
    TotTotali: "",
    username: window.UserP.username,
  };

  handleClear = () => {
    this.setState({
      date: "",
      pNga: new Date(),
      pDeri: new Date(),
      posts: [{}],
      terminal: [],
    });
  };
  handleChange = (value) => {
    this.setState({
      pNga: value,
    });
  };

  handleChange1 = (value) => {
    this.setState({
      pDeri: value,
    });
   
  };
  componentDidMount() {
    {
      fetch(window.UserP.url + "POD/GetPerdorues", {
        method: "Post",
        headers: {
          Accept: "application/json",
          "Content-type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
        body: JSON.stringify({
          Token: HmacSHA256(
            Math.round(new Date().getTime() / 1000).toString(),
            window.UserP.key
          ).toString(),
           username: this.state.username,
          Id: window.UserP.agencyId,
        }),
      })
        .then((res) => res.json())
        .then((data) => this.setState({ data3: data }));
    }

    {
      fetch(window.UserP.url + "POD/GetTerminal", {
        method: "Post",
        headers: {
          Accept: "application/json",
          "Content-type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
        body: JSON.stringify({
          Token: HmacSHA256(
            Math.round(new Date().getTime() / 1000).toString(),
            window.UserP.key
          ).toString(),
           username: this.state.username,
          Id: window.UserP.agencyId,
        }),
      })
        .then((res) => res.json())
        .then((data) => this.setState({ data2: data }));
    
    }
  }

  convertToDropDown = (par) => {
    var ret = [];
    var paramArray = par;

    for (var i in paramArray) {
      var objItem = { value: "", label: "" };
      objItem.value = paramArray[i];
      objItem.label = paramArray[i];
      ret.push(objItem);
    }

    return ret;
  };

  filter_array(test_array) {
    var index = -1,
      arr_length = test_array ? test_array.length : 0,
      resIndex = -1,
      result = [];

    while (++index < arr_length) {
      var value = test_array[index];

      if (value) {
        result[++resIndex] = value;
      }
    }

    return result;
  }
  printfunction = (post) => {
    var windowName = "";
    var windowUrl = " ";
    var myWindow = window.open(
      windowUrl,
      windowName,
      "left=0,top=0,right=0,bottom=0 margin=0,0,0,0"
    );

    var b = "&nbsp";
    let test = this.state.posts;

    var test5 =
      "&nbsp" +
      "<tr>" +
      "<th >" +
      "Agjensia: " +
      window.UserP.agencyId +
      "<br>" +
      "Perdoruesi:" +
      this.state.perdorues.label +
      "<br>" +
      "Terminali:" +
      this.state.terminal.label +
      "&nbsp" +
      "&nbsp" +
      "&nbsp" +
      "&nbsp" +
      "&nbsp" +
      "&nbsp" +
      "Periudha" +
      this.state.pNga.toLocaleDateString() +
      "___" +
      this.state.pDeri.toLocaleDateString() +
      "<br>" +
      "</th>" +
      "<br>" +
      "<br>" +
      "<font face='calibri'" +
      ">" +
      "<br>" +
      "&nbsp" +
      "&nbsp" +
      "<br>" +
      "<br>" +
      "<b>" +
      "   </tr>" +
      "<table border='1' >" +
      "<thead>" +
      "<tr>" +
      "<th class='cell'>" +
      "Nr_POD" +
      "</th>" +
      " <th class='cell'>" +
      "Kod_Levizje" +
      "</th>" +
      "<th class='-cell'>" +
      "Pesha__kg_" +
      "</th>" +
      "<th class='-cell'>" +
      "Pershkrimi" +
      "</th>" +
      "<th class='-cell'>" +
      "Menyre_Pagese" +
      "</th>" +
      "<th class='-cell'>" +
      "Kodi_Produktit" +
      "</th>" +
      "<th class='-cell'>" +
      "Vl.Blerje" +
      "</th>" +
      "<th class='-cell'>" +
      "Mondedhe Blerjeje" +
      "</th>" +
      "<th class='-cell'>" +
      "Shtese" +
      "</th>" +
      "<th class='-cell'>" +
      "Takse" +
      "</th>" +
      "<th class='-cell'>" +
      "Vl. Sig" +
      "</th>" +
      "<th class='-cell'>" +
      "Tvsh" +
      "</th>" +
      "<th class='-cell'>" +
      "Cmimi.ZBritje" +
      "</th>" +
      "<th class='-cell'>" +
      "Totali" +
      "</th>" +
      "<th class='-cell'>" +
      "Data" +
      "</th>" +
      "  </tr>" +
      "  </thead>";

    for (var i = 0; i < test.length; i++) {
      test5 +=
        "  <tbody>" +
        "<tr class='firstRow'>" +
        "<td class='Nr_POD:-cell'>" +
        test[i].Nr_POD +
        "</td>" +
        " <td class='Kod Levizje:-cell'>" +
        test[i].Kod_Levizje +
        "</td>" +
        " <td class='Pesha__kg_:-cell'>" +
        test[i].Pesha__kg_ +
        "</td>" +
        " <td class='Pershkrimi:-cell'>" +
        test[i].Pershkrimi +
        "</td>" +
        " <td class='Menyre_Pagese:-cell'>" +
        test[i].Menyre_Pagese +
        "</td>" +
        " <td class='Kodi_Produktit:-cell'>" +
        test[i].Kodi_Produktit +
        "</td>" +
        " <td class='Vl.Blerje:-cell'>" +
        test[i].Vlera_Kunder_Pagese +
        "</td>" +
        " <td class='Mondedhe Blerjeje:-cell'>" +
        test[i].Monedha_Kunder_Pagese +
        "</td>" +
        " <td class='Shtese:-cell'>" +
        test[i].Shtesa +
        "</td>" +
        " <td class='Takse:-cell'>" +
        test[i].Takse_Karburant_Leke +
        "</td>" +
        " <td class='Vl. Sig:-cell'>" +
        test[i].Vl__Sig_ +
        "</td>" +
        " <td class='Tvsh:-cell'>" +
        test[i].Tvsh +
        "</td>" +
        " <td class='Cmimi.ZBritje:-cell'>" +
        test[i].Cmimi_me_zbritje +
        "</td>" +
        " <td class='Totali:-cell'>" +
        test[i].Totali +
        "</td>" +
        " <td class='Data:-cell'>" +
        moment(test[i].Data).format("DD/MM/YYYY") +
        "</td>" +
        "   </tr>" +
        "&nbsp" +
        "&nbsp" +
        "</tr>";
    }//

    test5 +=
      "</table>" +
      "Total Blerje LEKE:   " +
      this.state.KPLeke +
      Array(42)
        .fill("&nbsp")
        .join("") +
      "Tot.Shtese:" +
      this.state.TotShtese +
      "<br>" +
      "Total Blerje EURO:   " +
      this.state.KPEuro +
      Array(40)
        .fill("&nbsp")
        .join("") +
      "Tot.Takse:   " +
      this.state.TotTakse +
      "<br>" +
      "<b>" +
      Array(82)
        .fill("&nbsp")
        .join("") +
      "Tot.VlSig:   " +
      this.state.TotSig +
      "<br>" +
      "<b>" +
      Array(82)
        .fill("&nbsp")
        .join("") +
      "Tot.Tvsh: " +
      this.state.TotTvsh +
      "<br>" +
      "<b>" +
      Array(82)
        .fill("&nbsp")
        .join("") +
      "Tot.C.Baze:   " +
      this.state.TotCmimiBaze +
      "<br>" +
      "<b>" +
      Array(82)
        .fill("&nbsp")
        .join("") +
      "Tot.Totali:   " +
      this.state.TotTotali +
      "</tbody></font>";
    myWindow.document.write(test5);

    myWindow.focus();

    myWindow.print();
  };

  handleClick = (e) => {
    const RaportReq = {
      pNga: moment(this.state.pNga).format("MM/DD/YYYY"),
      pDeri: moment(this.state.pDeri).format("MM/DD/YYYY"),
      Token: HmacSHA256(
        Math.round(new Date().getTime() / 1000).toString(),
        window.UserP.key
      ).toString(),
      PerdoruesId: window.UserP.PerdoruesId,
      PerdoruesName: window.UserP.username,
      ProcesorId: window.UserP.idProcesori,
      username: this.state.username,
      Agjensi: window.UserP.agencyId,
      PerdoruesAgjensi: this.state.perdorues.label,
      Terminal: this.state.terminal.label,
    };
 

    this.setState({ loading: true }, () => {
      axios
        .post(window.UserP.url + "POD/TransactionLogGrumbullimeArka", RaportReq)
        .then((response) => {
          this.setState({
            loading: false,
            posts: response.data,
          });



          let valueAdded = 0;
          let vleraPakosLeke = 0;
          let vleraPakosEuro = 0;
          let totalLek = 0;
          let totShtese = 0;
          let totTakse = 0;
          let totSig = 0;
          let totTvsh = 0;
          let total = 0;

          for (var i = 0; i < this.state.posts.length; i++) {
            if (this.state.posts[i].Monedha_Kunder_Pagese == "LEKE") {
              vleraPakosLeke += parseFloat(
                this.state.posts[i].Vlera_Kunder_Pagese
              );
            } else {
              vleraPakosEuro += parseFloat(
                this.state.posts[i].Vlera_Kunder_Pagese
              );
            }
            totShtese += parseFloat(this.state.posts[i].Shtesa);
            totTakse += parseFloat(this.state.posts[i].Takse_Karburant_Leke);
            totSig += parseFloat(this.state.posts[i].Vl__Sig_);
            totTvsh += parseFloat(this.state.posts[i].Tvsh);
            valueAdded += parseFloat(this.state.posts[i].Cmimi_me_zbritje);
            total += parseFloat(this.state.posts[i].Totali);
          }

          this.setState({
            KPLeke: thousands_separators(vleraPakosLeke.toFixed(2)),
            KPEuro: thousands_separators(vleraPakosEuro.toFixed(2)),
            TotShtese: thousands_separators(totShtese.toFixed(2)),
            TotTakse: thousands_separators(totTakse.toFixed(2)),
            TotSig: thousands_separators(totSig.toFixed(2)),
            TotTvsh: thousands_separators(totTvsh.toFixed(2)),
            TotCmimiBaze: thousands_separators(valueAdded.toFixed(2)),
            TotTotali: thousands_separators(total.toFixed(2)),
          });

          console.log(this.state.posts);
          this.printfunction(this.state.posts);
        })
        .catch((error) => {
          this.setState({
            loading: false,
          });
          alert(error + " Ju lutem kontaktoni departamentin e IT!");
        });
    });
  };
  onChangeFunc = (name) => (value) => {
    this.setState({
      [name]: value,
    });
  };

  render() {
    return (
      <div className="Form2">
        {this.state.loading ? (
          <LoadingSpinner />
        ) : (
          <div className="card card-body bg-light col-md-11">
            <div className="row">
              <div className="col-md-3">
                <label className=""> &nbsp; &nbsp; Nga</label>
              </div>
              <div className="col-md-3">
                <DatePicker
                  locale="en-NZ"
                  onChange={this.handleChange}
                  value={this.state.pNga}
                  name="pNga"
                  dateFormat="Pp"
                />
              </div>
              <div className="col-md-3">
                <label> &nbsp; &nbsp; Kodi I Terminalit</label>
              </div>
              <div className="col-md-3">
                <Select
                  className=""
                  //value={this.state.terminal}
                  defaultValue={{ value: "True", label: "Te Gjitha" }}
                  onChange={this.onChangeFunc("terminal")}
                  options={this.convertToDropDown(this.state.data2)}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-3">
                <label className=""> &nbsp; &nbsp; Deri</label>
              </div>
              <div className="col-md-3">
                <DatePicker
                  locale="en-NZ"
                  onChange={this.handleChange1}
                  value={this.state.pDeri}
                  name="pDeri"
                  dateFormat="Pp"
                />
              </div>

              {/* <div className="row mt-9"> */}

              <div className="col-md-3">
                <label> &nbsp; &nbsp; Perdoruesi</label>
              </div>
              <div className="col-md-3">
                <Select
                  className="mt-2"
                  // value={this.state.perdorues}
                  defaultValue={{ value: "True", label: "Te Gjitha" }}
                  onChange={this.onChangeFunc("perdorues")}
                  options={this.convertToDropDown(this.state.data3)}
                />
              </div>
            </div>
            <div className="row mt-4 ">
              <div className="col-md-6">
                <button
                  onClick={() => this.handleClick()}
                  className="btn btn-primary "
                >
                  <span data-notify="icon" className="pe-7s-print" />
                  &nbsp; Printo
                </button>
              </div>
              <div className="col-md-6">
                <button
                  className="btn btn-primary float-right"
                  // type="submit"
                  onClick={this.handleClear}
                >
                  <span data-notify="icon" className="pe-7s-trash" />
                  &nbsp; Pastro
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default RaportGrumbullimeArka;
